import AppLayout from "@/layouts/AppLayout";
import { Navigate, Outlet } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";
import Breadcrumb from "@/components/Breadcrumb";
import { usePersonAdminToolsAccess } from "../_utils";

export default function AdminToolsLayout() {
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();
  const { loaded, canAccessAdminTools } = usePersonAdminToolsAccess();

  if (shouldRenderError || !pgaId) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  if (loaded && !canAccessAdminTools) {
    return (
      <AppLayout navLinks={navLinks} interior bottomBar>
        <Navigate to={`/people/${pgaId}/person/overview`} replace />
      </AppLayout>
    );
  }

  if (!loaded) {
    return (
      <AppLayout navLinks={navLinks} interior bottomBar>
        <Breadcrumb compactOnly compactTitle="Admin Tools" backLink={{ to: "/people/:pgaId", params: { pgaId } }} />
        <PersonObjectHeading pgaId={pgaId} />
      </AppLayout>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <Breadcrumb compactOnly compactTitle="Admin Tools" backLink={{ to: "/people/:pgaId", params: { pgaId } }} />
      <PersonObjectHeading pgaId={pgaId} />
      <Outlet />
    </AppLayout>
  );
}
